import {
  PersistedType,
  type PersistedTypeAttributesType
} from './Ambiguous'

export class LoadedPersistedType<T extends PersistedTypeAttributesType = PersistedTypeAttributesType> extends PersistedType<T> {
  readonly isLoaded: true = true

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor (attributes: T) {
    super(attributes)
  }

  /* eslint-disable @typescript-eslint/class-literal-property-style */
  get isAtom (): true { return true }
  get isAggregate (): true { return true }
  /* eslint-enable @typescript-eslint/class-literal-property-style */
}
